module.exports = __webpack_public_path__ + "img/verify-img2.1fb80b1b.jpg";